import { Body, Container } from "./TrialMode.styled";
import { observer } from "mobx-react";
import { useStores } from "../../../stores";
import { createLabel } from "../../../helpers";
import { ImagePng } from "../ImagePng/ImagePng";
import { useTranslation } from "react-i18next";

export const TrialMode = observer(() => {
	const { t } = useTranslation();

	const { authStore } = useStores();
	const { userStore } = authStore;

	if (!authStore.isAuth) {
		return null;
	}

	if (authStore.userStore.existPurchases) {
		return null;
	}

	return (
		<Container>
			<ImagePng src={"/images/arrow-right"} />
			<Body>
				{1 < 5 ? t("titles.trial.endsIn", { count: userStore.trial_version.days_remain }) : t("titles.trial.ended")}
			</Body>
			<ImagePng src={"/images/arrow-right"} className={"arrow-left"} />
		</Container>
	);
});
